<template>
  <div class="index" >
    <el-container>
<!--      <el-badge :value="100" :max="10" class="item right" @click.native="shop_cart">-->
<!--        <span class="el-icon-shopping-cart-full" style="font-size: 25px"></span>-->
<!--      </el-badge>-->

      <el-header style="padding-left: 200px; padding-right: 0px">
        <el-menu
          background-color="#7A8B8B"
          text-color="#fff"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="1">
            <router-link :to="{ name: 'admin' }"> 首页概况</router-link>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">我的工作台</template>
            <el-menu-item index="2-1" @click="logout">退出</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-container>

        <el-aside width="200px">

          <el-menu  ref="nav_menu" @select="select_menu" @close="close_menu" >

              <el-submenu :index="index+'_'+item.id" v-for="(item,index) in menu_list" :key="index+'_'+item.id"    >
                  <template slot="title" >
                      <span v-html="item.icons"></span>
                      {{ item.title }}</template>

                  <el-menu-item :index="index+'_'+item.id+'_'+item1.id" v-for="(item1,index1) in item.children" :key="index1+'_'+index+'_'+item1.id"  >

                      <router-link  :to="{ name: item1.name }"> {{item1.title}}</router-link>

                    </el-menu-item>


              </el-submenu>

          </el-menu>
        </el-aside>
        <el-main>
          <div>
            <slot name="breadcrumb"></slot>
          </div>

          <router-view> </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
        show_path:['1','2','3'],
        menu_list:{},

    };
  },
  methods: {
      ...mapActions({
          getPermissionMenuAction: "getPermissionMenuAction",
      }),
    show_url(name,p){
          this.$router.push({name,params: { p }})
    },
    shop_cart() {
      this.$router.push({
        name: "shop_cart",
      });
    },
    home() {
      this.$router.push({
        name: "index",
      });
    },
    logout() {
      localStorage.removeItem("sh_admin_user_data");
      sessionStorage.removeItem("router_list")

      this.$router.push({
        name: "admin_login",
      });
    },
      close_menu(index,indexPath){

          console.log(index,)

          let path=indexPath[0]

          if(this.show_path.includes(path)){

              // this.show_path.push(path)
              this.show_path.splice(this.show_path.findIndex(item => item === path), 1)

          }
      },
      permissions_menu(){

       console.log("routes",this.$router.options.routes)
      },
      select_menu(index,indexPath){

            console.log(index,)

          let path=indexPath[0]

         if(!this.show_path.includes(path)){

             this.show_path.push(path)
         }
          // this.$refs.nav_menu.open(6)
      }
  },
  created() {


      //  this.$router.addRoutes([router_list])
  },
    mounted() {

      // this.permissions_menu()
      this.getPermissionMenuAction({})
  },
  computed: {
        ...mapState({
            permission_result: (state) => state.menu.result,
        }),


    },
    watch: {
        permission_result(val){
            if(val.code==302){

                let menu= Object.assign({}, val.data)


                for (let k in menu){
                   let item=[]
                    for(let kk in menu[k]["children"]){
                        // let params=menu[k]["children"][kk]["params"]
                        let isshow=menu[k]["children"][kk]['isshow']

                        if(isshow!="0"){

                            item.push(menu[k]["children"][kk])

                        }


                    }
                    this.$set(menu[k],"children",item)
                }
                this.menu_list=menu


            }

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;

  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
}

.el-aside .el-menu-item a,
.el-menu-item a:hover {
  color: inherit;
  font-size: 14px;
  text-decoration: none;
}
.item {
  margin-top: 20px;
  margin-right: 40px;
}

.right {
  right: 10px;
  position: absolute;
  z-index: 99999;
}
</style>
